// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import { type APIPromise, APIResource, type FetchParams } from "../../core";

import type { Membership, MembershipStatus, ResourceType } from "../../types";
export type ListMembershipsQueryParams = {
  offset?: number;
  limit?: number;
  kind?: ResourceType;
  status?: MembershipStatus;
  "resource.type"?: ResourceType;
  "resource.attributes.sandbox"?: boolean;
  "resource.name"?: string;
  "resource.parent.id"?: string | null;
  "resource.parent.type"?: ResourceType | null;
  roles?: string[];
};

export type ListMembershipsResponse = {
  items: Membership[];
  total_count: number;
};

export class Memberships extends APIResource {
  /**
   * List memberships of the current user.
   */
  list(
    query?: ListMembershipsQueryParams,
    params?: FetchParams,
  ): APIPromise<ListMembershipsResponse, unknown> {
    return this._client.get<ListMembershipsResponse, unknown>({
      path: `/v0.1/memberships`,
      query,
      ...params,
    });
  }
}
